import { RoundButtonWithToggleIcon } from "@/components/tools/RoundButtonWithToggleIcon";
import { StarIcon } from "@heroicons/react/24/solid";
import {
  ArrowTopRightOnSquareIcon,
  StarIcon as StarIconOutline,
} from "@heroicons/react/24/outline";
import { RoundButtonWithIcon } from "@/components/tools/RoundButtonWithIcon";
import { TrashButton } from "@/components/tools/TrashButton";
import React, { useEffect, useState } from "react";
import { EstateCardProp } from "@/types";
import { RoundButtonsContainer } from "@/components/tools/RoundButtonsContainer";
import { useLanguage } from "@/context/LanguageContext";

export function ResultActionIcons({
  estateOffer,
  editSpecificResult,
}: EstateCardProp) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      removeFavorite: "Odebrat z oblíbených",
      saveFavorite: "Uložit do oblíbených",
      deleteListing: "Smazat inzerát",
      deleteListingTitle: "Opravdu chcete smazat inzerát?",
      cannotUndo: "Tuto akci nelze vrátit zpět.",
      openListing: "Otevřít inzerát",
    },
    en: {
      removeFavorite: "Remove from favorites",
      saveFavorite: "Save to favorites",
      deleteListing: "Delete listing",
      deleteListingTitle: "Do you really want to delete this listing?",
      cannotUndo: "This action cannot be undone.",
      openListing: "Open listing",
    },
  }[language];
  const [isFavorite, setIsFavorite] = useState(estateOffer.isFavorite);

  useEffect(() => {
    setIsFavorite(estateOffer.isFavorite);
  }, [estateOffer.isFavorite]);

  const toggleFavorite = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const newFavoriteStatus = !isFavorite;
    setIsFavorite(newFavoriteStatus);
    editSpecificResult(estateOffer.id, newFavoriteStatus, false);
  };

  const hideFromUser = async () => {
    await editSpecificResult(estateOffer.id, false, true);
  };

  const openOffer = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(estateOffer.offerUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <RoundButtonsContainer>
      <RoundButtonWithToggleIcon
        icon={isFavorite ? StarIcon : StarIconOutline}
        isActive={isFavorite}
        onClick={toggleFavorite}
        tooltipTextActive={copy.removeFavorite}
        tooltipTextInactive={copy.saveFavorite}
        activeClassName="text-yellow-500 hover:text-yellow-500"
        inactiveClassName="text-yellow-500 hover:[&_svg]:fill-current"
      />

      <TrashButton
        label={copy.deleteListing}
        confirmTitle={copy.deleteListingTitle}
        confirmDescription={copy.cannotUndo}
        onClick={hideFromUser}
        stopPropagation
        iconClassName="size-4"
      />

      <RoundButtonWithIcon
        icon={ArrowTopRightOnSquareIcon}
        text={copy.openListing}
        onClick={openOffer}
        stopPropagation
        iconClassName="size-4"
      />
    </RoundButtonsContainer>
  );
}
